import React from 'react';
import {NamedStyles, StyleHelper, useStyles} from '../../../../../../shared/hooks/styles';
import Screen from '../../../../../../shared/components/screen';
import {View} from 'react-native';
import {CustomScrollView} from '../../../../../../shared/components/scrollView';
import {LinkedAccountItemDetails} from './details';
import {DeviceSize} from '../../../../../../shared/theme/helpers';

export function ProfileLinkedAccountsItem() {
  const styles = useStyles((helper) => createStyles(helper));
  return (
    <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
      <View style={styles.container}>
        <LinkedAccountItemDetails />
      </View>
    </CustomScrollView>
  );
}

const createStyles = ({theme}: StyleHelper): NamedStyles<any> => ({
  container: {
    marginTop: 15,
    paddingHorizontal: 16,
    paddingBottom: theme.screen.bottomOffset - 20,
  },
});
